import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LearningHub.css';

const LearningHub: React.FC = () => {
  const navigate = useNavigate();

  const screenerGuides = [
    {
      icon: '🤖',
      title: 'How to Trade Momentum AI Screener',
      description: 'Learn entry, exit, and risk management for momentum trades identified by our AI',
      readTime: '8 min',
      path: '/learning-hub/momentum-ai-guide'
    },
    // {
    //   icon: '📈',
    //   title: 'How to Trade Rocket Launch AI Screener',
    //   description: 'Identify trend continuation setups & timing with AI-powered analysis',
    //   readTime: '10 min',
    //   path: '/learning-hub/trend-continuation-guide'
    // },
    {
      icon: '📊',
      title: 'How to Trade Positive Gap Up Screener',
      description: 'Gap up entry strategies & risk management for profitable swing trades',
      readTime: '7 min',
      path: '/learning-hub/gap-up-guide'
    },
    {
      icon: '🚀',
      title: 'How to Trade IPO Bull Run Screener',
      description: 'Catch early IPO momentum with proper entries and exit strategies',
      readTime: '9 min',
      path: '/learning-hub/ipo-bull-guide'
    },
    {
      icon: '🎯',
      title: 'How to Trade VCP Screener',
      description: 'VCP pattern identification and trading for high-probability setups',
      readTime: '12 min',
      path: '/learning-hub/vcp-guide'
    },
    {
      icon: '🏴',
      title: 'How to Trade Bullish Flag & Pennant Screener',
      description: 'Flag & pennant breakout timing and target identification',
      readTime: '11 min',
      path: '/learning-hub/flag-pennant-guide'
    },
    {
      icon: '📏',
      title: 'How to Trade Narrow Range Screener',
      description: 'Narrow range breakout setups and execution strategies',
      readTime: '8 min',
      path: '/learning-hub/narrow-range-guide'
    },
    {
      icon: '⛰️',
      title: 'How to Trade Mountain Scoop Screener',
      description: 'Scoop pattern recognition & trade execution for swing profits',
      readTime: '10 min',
      path: '/learning-hub/mountain-scoop-guide'
    }
  ];

  return (
    <div className="learning-hub">
      {/* Hero Section */}
      <section className="learning-hero">
        <div className="learning-hero-content">
          <h1 className="learning-hero-title">
            📚 Swing Trading Learning Hub
          </h1>
          <p className="learning-hero-subtitle">
            Learn how to use our AI screeners and master profitable swing trading techniques
          </p>
        </div>
      </section>

      {/* Featured Learning Section */}
      <section className="featured-learning">
        <div className="featured-badge">⭐ Must Read for All Traders</div>
        <div className="featured-card">
          <div className="featured-tag">FEATURED</div>
          <h2 className="featured-title">
            Smart Stop-Loss Techniques for Profitable Swing Trading
          </h2>
          <p className="featured-description">
            Master the art of protecting your capital while letting winners run. Learn ATR-based stops,
            trailing stops, and support-based techniques that professional traders use to achieve
            consistent profitability in swing trading.
          </p>
          <div className="featured-meta">
            <span className="read-time">⏱️ 15 min read</span>
            <span className="difficulty essential">Essential for All Traders</span>
          </div>
          <button className="featured-button" onClick={() => navigate('/learning-hub/smart-stoploss')}>
            Read Full Guide →
          </button>
        </div>
      </section>

      {/* AI Screener Tutorials Section */}
      <section className="screener-tutorials">
        <h2 className="section-title">How to Trade with Our AI Screeners</h2>
        <div className="tutorials-grid">
          {screenerGuides.map((guide, index) => (
            <div key={index} className="tutorial-card">
              <div className="tutorial-icon">{guide.icon}</div>
              <h3 className="tutorial-title">{guide.title}</h3>
              <p className="tutorial-description">{guide.description}</p>
              <div className="tutorial-footer">
                <span className="tutorial-time">⏱️ {guide.readTime}</span>
                <button className="tutorial-button" onClick={() => navigate(guide.path)}>
                  Read Guide →
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default LearningHub;
